var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSantevet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 163.602,
    height: 67,
    viewBox: "0 0 163.602 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2573",
    "data-name": "Groupe 2573",
    transform: "translate(-142.648 -89.71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1549",
    "data-name": "Trac\\xE9 1549",
    d: "M440.478,191.3l-2-14.27h0c-2.7,1.09-4.177,3.328-3.731,6.039L437,194.445a4.522,4.522,0,0,0,4.36,3.755h.846l11.537-28.123-1.614.241a6.167,6.167,0,0,0-4.753,3.859Z",
    transform: "translate(-187.109 -51.495)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1550",
    "data-name": "Trac\\xE9 1550",
    d: "M208.551,191.937c-2.256-3.856-7.972-4.512-11.555-2.174-4.7,2.837-5.882,9.875-3.425,14.593a8.743,8.743,0,0,0,14.98,1.693v3.494h4.025V187.78A6.242,6.242,0,0,0,208.551,191.937Zm-.786,10.484a5.8,5.8,0,0,1-10.428,0c-2.06-4.089.028-10.189,5.176-10.146C207.715,192.215,209.838,198.279,207.764,202.421Z",
    transform: "translate(-31.828 -62.838)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1551",
    "data-name": "Trac\\xE9 1551",
    d: "M275.523,189.318c-3.884-1.968-8.752-.518-10.529,2.779v-.011a4,4,0,0,0-3.165-4.152l-.822-.153v21.764h3.987V197.866a4.949,4.949,0,0,1,5.07-4.868c3.437,0,4.624,1.99,4.568,4.948v7.659a3.938,3.938,0,0,0,3.939,3.938h.049V197.66C278.574,194.5,278.417,190.834,275.523,189.318Z",
    transform: "translate(-75.838 -62.838)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1552",
    "data-name": "Trac\\xE9 1552",
    d: "M545.943,169.854h0l.046,7.029H543.32v3.487h2.669v13.016l.078.682a4.559,4.559,0,0,0,3.862,3.989h0V180.37h1.946a3.158,3.158,0,0,0,3.125-2.7l.114-.784-5.185,0,.018-1.968C549.948,172.058,548.947,169.854,545.943,169.854Z",
    transform: "translate(-256.73 -51.352)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1553",
    "data-name": "Trac\\xE9 1553",
    d: "M379.911,171.291h0a5.956,5.956,0,0,0-7.347-.324l-3.619,2.591h0a4.5,4.5,0,0,0,5.11.715Z",
    transform: "translate(-144.999 -51.352)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1554",
    "data-name": "Trac\\xE9 1554",
    d: "M373.833,192.247a9.235,9.235,0,0,0-2.961-2.071,8.98,8.98,0,0,0-3.677-.755,10.78,10.78,0,0,0-4.162.794,9.453,9.453,0,0,0-3.29,2.245,10.484,10.484,0,0,0-2.148,3.426,11.875,11.875,0,0,0-.774,4.374A10.288,10.288,0,0,0,358.2,205.6a9.842,9.842,0,0,0,3.794,3.658,11.3,11.3,0,0,0,5.555,1.336,11.071,11.071,0,0,0,2.922-.407,14.12,14.12,0,0,0,2.826-1.1,9.169,9.169,0,0,0,2.264-1.626h0a5.066,5.066,0,0,0-3.495-1.239,6.716,6.716,0,0,0-1.324.232,9.623,9.623,0,0,1-2.807.5,8.029,8.029,0,0,1-3.755-.851,6.063,6.063,0,0,1-2.516-2.419,6.9,6.9,0,0,1-.836-2.69h15.546l.039-1.7a10.548,10.548,0,0,0-.639-3.929A9.091,9.091,0,0,0,373.833,192.247Zm-10.161,1.645a7.187,7.187,0,0,1,3.523-.793,5.278,5.278,0,0,1,4.3,2.167,4.493,4.493,0,0,1,.851,2.284v.271H360.976a6.982,6.982,0,0,1,.529-1.607A5.119,5.119,0,0,1,363.672,193.892Z",
    transform: "translate(-137.231 -63.89)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1555",
    "data-name": "Trac\\xE9 1555",
    d: "M498.876,192.247a9.241,9.241,0,0,0-2.961-2.071,8.981,8.981,0,0,0-3.678-.755,10.777,10.777,0,0,0-4.161.794,9.451,9.451,0,0,0-3.29,2.245,10.488,10.488,0,0,0-2.148,3.426,11.873,11.873,0,0,0-.774,4.374,10.286,10.286,0,0,0,1.374,5.342,9.838,9.838,0,0,0,3.793,3.658,11.3,11.3,0,0,0,5.555,1.336,11.073,11.073,0,0,0,2.922-.407,14.125,14.125,0,0,0,2.826-1.1,9.17,9.17,0,0,0,2.265-1.626h0a5.066,5.066,0,0,0-3.5-1.239,6.716,6.716,0,0,0-1.324.232,9.62,9.62,0,0,1-2.807.5,8.03,8.03,0,0,1-3.755-.851,6.064,6.064,0,0,1-2.516-2.419,6.9,6.9,0,0,1-.837-2.69h15.546l.039-1.7a10.541,10.541,0,0,0-.639-3.929A9.1,9.1,0,0,0,498.876,192.247Zm-10.161,1.645a7.186,7.186,0,0,1,3.523-.793,5.277,5.277,0,0,1,4.3,2.167,4.488,4.488,0,0,1,.851,2.284v.271H486.019a6.961,6.961,0,0,1,.529-1.607A5.12,5.12,0,0,1,488.715,193.892Z",
    transform: "translate(-217.352 -63.89)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1556",
    "data-name": "Trac\\xE9 1556",
    d: "M156.12,200.211c-1.338-1.332-3.035-1.869-5.121-2.446a10.407,10.407,0,0,1-3.4-1.3,2.342,2.342,0,0,1-.841-1.682c-.046-1.833,1.849-2.457,3.439-2.407a7.141,7.141,0,0,1,4.737,2.26l2.448-2.3c-2.872-3.446-8.883-4.363-12.477-1.586a5.489,5.489,0,0,0-.975,7.624c1.439,1.618,3.41,2.284,5.809,2.943a12.293,12.293,0,0,1,3.325,1.261,2.279,2.279,0,0,1-.172,3.478,3.9,3.9,0,0,1-2.312.688,8.86,8.86,0,0,1-7.249-2.961l-.066.089a3.321,3.321,0,0,0,1.166,4.826c3.14,1.936,8.763,2.815,11.684-.577C157.67,206.315,157.875,201.891,156.12,200.211Z",
    transform: "translate(0 -63.696)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1557",
    "data-name": "Trac\\xE9 1557",
    d: "M322.522,169.854h0v7.029h-2.67v3.487h2.67v13.016l.072.628a4.574,4.574,0,0,0,3.868,4.043h0V180.37h1.946a3.158,3.158,0,0,0,3.124-2.7l.115-.784-5.185,0v-1.866C326.462,172.161,325.525,169.854,322.522,169.854Z",
    transform: "translate(-113.543 -51.352)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2508",
    "data-name": "Groupe 2508",
    transform: "translate(237.119 89.71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1558",
    "data-name": "Trac\\xE9 1558",
    d: "M474.744,148.669l-42.507,7.776A16.1,16.1,0,0,1,413.5,143.5l-7.887-43.12L463.96,89.71Z",
    transform: "translate(-405.614 -89.71)",
    fill: "#6cbe99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1559",
    "data-name": "Trac\\xE9 1559",
    d: "M545.889,169.813h0l.046,7.026h-2.668v3.484h2.668v13.01l.078.682a4.557,4.557,0,0,0,3.86,3.987h0V180.323h1.945a3.156,3.156,0,0,0,3.123-2.7l.114-.783-5.182,0,.018-1.967C549.892,172.016,548.891,169.813,545.889,169.813Z",
    transform: "translate(-493.815 -141.036)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1560",
    "data-name": "Trac\\xE9 1560",
    d: "M498.846,192.194a9.221,9.221,0,0,0-2.96-2.07,8.972,8.972,0,0,0-3.676-.754,10.772,10.772,0,0,0-4.159.793,9.446,9.446,0,0,0-3.289,2.244,10.489,10.489,0,0,0-2.147,3.424,11.871,11.871,0,0,0-.774,4.372,10.282,10.282,0,0,0,1.374,5.339,9.836,9.836,0,0,0,3.791,3.656,11.3,11.3,0,0,0,5.552,1.335,11.075,11.075,0,0,0,2.921-.406,14.1,14.1,0,0,0,2.824-1.1,9.16,9.16,0,0,0,2.264-1.625h0a5.065,5.065,0,0,0-3.493-1.238,6.739,6.739,0,0,0-1.323.232,9.615,9.615,0,0,1-2.805.5,8.027,8.027,0,0,1-3.753-.851,6.062,6.062,0,0,1-2.515-2.418,6.9,6.9,0,0,1-.836-2.689H501.38l.039-1.7a10.543,10.543,0,0,0-.638-3.927A9.09,9.09,0,0,0,498.846,192.194Zm-10.156,1.644a7.181,7.181,0,0,1,3.521-.793,5.277,5.277,0,0,1,4.295,2.166,4.489,4.489,0,0,1,.851,2.283v.271H485.995a6.972,6.972,0,0,1,.528-1.606A5.116,5.116,0,0,1,488.69,193.838Z",
    transform: "translate(-454.457 -153.567)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1561",
    "data-name": "Trac\\xE9 1561",
    d: "M440.983,191.477l-2.064-14.5c-2.606,1.054-4.031,3.216-3.6,5.834l2.307,11.706a4.366,4.366,0,0,0,4.212,3.623h.817l11.449-28.108-1.558.234a5.957,5.957,0,0,0-4.588,3.73Z",
    transform: "translate(-424.599 -141.178)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSantevet);
export default __webpack_public_path__ + "static/media/santevet.970e615a77d73586712e7076688e85c8.svg";
export { ForwardRef as ReactComponent };